module.exports = __webpack_public_path__ + "static/st2-10-454066c9a32188f58975a370a1d359a9.jpg";